// extracted by mini-css-extract-plugin
module.exports = {"daysTabCont":"timeSlotStyles_daysTabCont__2Q3_V","active":"timeSlotStyles_active__21YY0"};